import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MappingComponent } from '../../mapping/mapping.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-delete-indent-field',
    templateUrl: './delete-indent-field.component.html',
    styleUrls: ['./delete-indent-field.component.css'],
    standalone: false
})
export class DeleteIndentFieldComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<MappingComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) {
    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close({"option": "cancel"});
    });
   }

  ngOnInit(): void {
  }

  deleteSpace() {
    this.dialogRef.close({"option": "delete"});
  }

  cancel(): void {
    this.dialogRef.close({"option": "cancel"});
  }

}
